// Liquidから出力したJSONを取得
const rawData = document.getElementById('variant-metafields').textContent;
const data = rawData.replace(/"((?:\\.|[^"\\])*)"/g, function(match) {
  // マッチした「"値"」の中にある改行コードを置換
  return match.replace(/\r?\n/g, '\\n');
});
const metafieldsData = JSON.parse(data);

// 「サイズ」セレクトボックスの変更イベント
$('select[name="options[\u30B5\u30A4\u30BA]"]').on("change", function () {
  // 選択された値を取得
  let val1 = $(this).val();
  console.log(val1);

  // 1秒後に呼び出す関数（価格情報を転記）
  var fn1 = function () {
    // 元の価格と下限価格のテキストを取得
    let price1 = $("#target_price-1").text(),
      low_price1 = $("#low_target_price-1").text();

    // 取得した値を別のエリア（-2）にコピー
    $("#low_target_price-2").text(low_price1),
      $("#target_price-2").text(price1);

    // サイズ情報の出力先（.size__boxクラスの要素を取得）
    const sizeBoxes = document.querySelectorAll('.size__box');
    if (!sizeBoxes) return;

    // 値を反映する関数
    function updateSizeBoxes(variantId) {
      console.log(variantId);
      variantId = variantId + " / " + $('select[name="options[\u6587\u5B57\u5165\u308C]"]').val();
      const metafield = metafieldsData[variantId];

      console.log(variantId);
      
      // すべての .size__box に対して更新
      sizeBoxes.forEach(function (box) {
        if (metafield && metafield.size_info) {
          // 「\\n」を <br> に置換してHTMLとして挿入
          box.innerHTML = metafield.size_info.replaceAll('\\n', '<br>');
          // もしIE11対応などreplaceAll未サポートなら↓
          // box.innerHTML = metafield.size_info.split('\\n').join('<br>');
        } else {
          box.textContent = '';
        }
      });
    }

    // メタフィールド値が存在すれば表示
    updateSizeBoxes(val1);
  };

  // 再度セレクトボックスの値を設定（バグ回避用の冗長コードに見える）
  $('select[name="options[\u30B5\u30A4\u30BA]"]').val(val1);
  // 1秒後にfn1を実行（価格表示の反映待ちのため遅延していると思われる）
  setTimeout(fn1, 1e3);
});

// 「文字入れ」セレクトボックスの変更イベント
$('select[name="options[\u6587\u5B57\u5165\u308C]"]').on("change", function () {
  // 選択された値を取得
  let val2 = $(this).val();

  // 1秒後に呼び出す関数（価格情報を転記）
  var fn2 = function () {
    // 元の価格と下限価格のテキストを取得
    let price2 = $("#target_price-1").text(),
      low_price2 = $("#low_target_price-1").text();

    // 取得した値を別のエリア（-2）にコピー
    $("#low_target_price-2").text(low_price2),
      $("#target_price-2").text(price2)
  };

  // 再度セレクトボックスの値を設定（バグ回避用？）
  $('select[name="options[\u6587\u5B57\u5165\u308C]"]').val(val2);
  // 1秒後にfn2を実行（価格表示の反映待ちのため遅延）
  setTimeout(fn2, 1e3);
});

// 「select-base」の値が変わった時、「select-target」の値も同期
$("#select-base").on("change", function () {
  let val3 = $(this).val();
  $("#select-target").val(val3);
});

// 「formClick」ボタンが押された時の処理
$("#formClick").on("click", function () {
  // 「add-cart-btn」ボタンを自動クリック
  $("#add-cart-btn").click();

  // 1秒後、エラーメッセージをもう1か所にもコピー
  var errfunc = function () {
    let errmsg = $("#target-error-message").text();
    $("#target-error-message2").text(errmsg);
  };
  setTimeout(errfunc, 1e3);
});
